<div id="admissions-ug" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">UG Admission Guidelines</h2>

    <div class="pdf-block mt-4">
      <pdf-viewer src="/assets/pdf/admission/Guidelines-UG-PG-Admission.pdf" [render-text]="true"
        [original-size]="false" style="width:100%; height:800px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-4 d-flex gap-3 justify-content-center">
      <a href="/assets/pdf/admission/Guidelines-UG-PG-Admission.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download me-2"></i> Download Guidelines
      </a>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLScZ3eOmPZ9h4PEXTBWP9cj_t3oxyVXorWj59UC8TX48k2XJHA/viewform"
        target="_blank" class="pdf-download-btn">
        <i class="fa fa-external-link me-2"></i> Online Registration
      </a>
    </div>
  </div>
</div>